import BaseLayout from "../components/layout/BaseLayout";
import { Profile } from "../components/Profile";

export const ProfilePage = () => (
    <BaseLayout>
        <Profile />
    </BaseLayout>
);